
function openPopup(pUrl, pWidth, pHeight) {
    if (!pWidth)  pWidth = 800;
    if (!pHeight) pHeight = 600;

    var sWidth  = screen.availWidth;
    var sHeight = screen.availHeight;
    var pTop    = sHeight / 2 - pHeight / 2;
    var pLeft   = sWidth / 2 - pWidth / 2;

    console.log(pWidth, pHeight, pTop, pLeft);

    window.open(pUrl, 'popup', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes' +
                    ',width=' + pWidth + ',height=' + pHeight + ',top=' + pTop + ',left=' + pLeft);
}


function checkSidebarHeight() {
	$('.sidebar').each(function() {
		var sidebarHeight = $(this).outerHeight(true);
		var windowHeight  = $(window).height();

		windowHeight -= $('.navbar-fixed-top').outerHeight();

		if (sidebarHeight > windowHeight) {
			$(this).addClass('no-affix');
		} else {
			$(this).removeClass('no-affix');
		}
	});
}


function printOnly($element) {
    $('body').addClass('print-nothing');
    $element.addClass('print');
    window.print();
    $element.removeClass('print');
    $('body').removeClass('print-nothing');
}


function isScrolledIntoView($element) {
    if ($element.length == 0 || !$element.is(':visible')) {
    	return false;
	}

    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $element.offset().top;
    var elemBottom = elemTop + $element.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


function getScrollbarWidth($element) {
    var remove = false;

    if (typeof($element) == undefined) {
        remove = true;
        var $element = $('<div style="height:1px;overflow-y:scroll;"/>').appendTo('body');
    }

    var scrollbarWidth = $element[0].offsetWidth - $element[0].clientWidth;
    if (remove) $element.remove();
    return scrollbarWidth;
}


var showKPIScoresRequest = {abort: function() {}};
var postKPIScoresRequest = {abort: function() {}};

function monitorKPIScores(itemSelector, answerUrl, callback) {
    $(itemSelector).filter('[type=number]').on('input', function(e, extra) {
        var $item = $(this);
        updateKPIScores($item, answerUrl, callback, $(this));
    });

    $(itemSelector).filter('[type!=number]').on('change', function(e, extra) {
        var $item = $(this);
        updateKPIScores($item, answerUrl, callback, $(this));
    });
}

function updateKPIScores($item, answerUrl, callback, changedElement) {
    if ($item.is(':disabled')) {
        return;
    }

    var $span  = $item.closest('span');
    var $clone = $item.clone();
    var $form  = $('<form />');

    if ($clone.attr('type') == 'checkbox' && !$clone.is(':checked')) {
        $clone.val('0').attr('type', 'hidden');
    }

    $clone.appendTo($form);
    $span.addClass('loading');

    postKPIScoresRequest.abort();
    showKPIScoresRequest.abort();

    if (answerUrl == '') {
        $span.removeClass('loading');

        if (typeof callback == 'function') {
            callback(changedElement);
        }

        return;
    }

    postKPIScoresRequest = $.post(answerUrl, $form.serialize(), function(data) {
        if (data == 'ok') {
            $span.removeClass('loading');

            if (typeof callback == 'function') {
                callback(changedElement);
            }
        }
    });
}

function showKPIScores(simulate, callback) {
    showKPIScoresRequest.abort();

    var formData = {};

    if (simulate) {
        // Temporarily remove the disabled attribute to include the disabled inputs values in serializeArray
        var $form      = $('form[name=scores_form]');
        var $disabled  = $form.find(':input:disabled').removeAttr('disabled');
        formData       = $form.serializeArray();
        $disabled.attr('disabled', 'disabled');
    }

    showKPIScoresRequest = $.getJSON('/site/ajax/get_kpi_scores.php', formData, function(data) {
        for (var kpi_nr in data.scores_perc) {
            $('.score-button[data-menu-button="kpi_' + kpi_nr + '"] .progress-score').width(data.scores_perc[kpi_nr] + '%');
            $('.score-button[data-menu-button="kpi_' + kpi_nr + '"] .progress-goal').width(data.goals_perc[kpi_nr] + '%');
        }

        $('.kpi-quarter-warning').addClass('hidden');

        $.each(data.warnings, function(type, type_warnings) {
            $.each(type_warnings, function(kpi_nr, kpi_warnings) {
                $.each(kpi_warnings, function(quarter, quarter_warning) {
                    $('.kpi-quarter-warning[data-type="' + type + '"][data-kpi="' + kpi_nr + '"][data-quarter="' + quarter + '"]')
                        .attr('data-warning', quarter_warning).removeClass('hidden');
                });
            });
        });

        // if (data.warning != '') {
        //     $('.kpi-warning').html(data.warning);
        //
        //     if (!$('.kpi-warning').is(':visible')) {
        //         $('.kpi-warning').slideDown();
        //     }
        //
        // } else {
        //     $('.kpi-warning').slideUp();
        // }

        setGrayGlassHeight(data.year_score_perc);
        setGlassHeight(data.year_goal_perc);

        $('.counter-perc').counter({
            start: parseFloat($('.counter-perc').data('counter-current')),
            end: data.year_score_perc,
            duration: 500,
            decimals: 1
        });

        $('.counter-score').counter({
            start: parseFloat($('.counter-score').data('counter-current')),
            end: data.score_total,
            duration: 500,
            decimals: 0
        });

        $('.counter-goal').counter({
            start: parseFloat($('.counter-goal').data('counter-current')),
            end: data.goal_total,
            duration: 500,
            decimals: 0
        });

        $('.counter-credits').counter({
            start: parseFloat($('.counter-credits').data('counter-current')),
            end: data.credits,
            duration: 500,
            decimals: 0
        });

        if (typeof callback == 'function') {
            callback();
        }
    });
}

function setGrayGlassHeight(perc) {
    // if (parseInt($('.progress-glass-bar-gray').height()) == perc) {
    //     return;
    // }

    $('.progress-glass-bar-2').show().animate({'height': perc + '%'}, 500, function() {
        if (perc == 0) {
            // $(this).fadeOut('fast');
        }
    });
}

function setGlassHeight(perc) {
    // if (parseInt($('.progress-glass-bar').height()) == perc) {
    //     return;
    // }

    $('.progress-glass-bar-1').show().animate({'height': perc + '%'}, 500, function() {
        if (perc == 0) {
            // $(this).fadeOut('fast');
        }
    });
}
